import { render, staticRenderFns } from "./FudaoStudentInviteSessionDialog.vue?vue&type=template&id=61b40245&scoped=true&"
import script from "./FudaoStudentInviteSessionDialog.vue?vue&type=script&lang=js&"
export * from "./FudaoStudentInviteSessionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b40245",
  null
  
)

export default component.exports